// extracted by mini-css-extract-plugin
export default {"root":"BackgroundMedia_root__9Vh7F","media":"BackgroundMedia_media__nNrAD"};